module.exports = __webpack_public_path__ + "static/img/user.6ca2763b.svg";